import { GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
const defaultTitle = __('CI/CD Catalog');
const defaultDescription = s__('CiCatalog|Discover CI/CD components that can improve your pipeline with additional functionality.');
export default {
    name: 'CatalogHeader',
    components: {
        GlLink
    },
    inject: {
        pageTitle: {
            default: defaultTitle
        },
        pageDescription: {
            default: defaultDescription
        },
        legalDisclaimer: {
            default: ''
        }
    },
    i18n: {
        learnMore: __('Learn more')
    },
    learnMorePath: helpPagePath('ci/components/_index')
};
